import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=0a3f6400"
import script from "../../services/ticketing/Tickets.js?vue&type=script&lang=js&external"
export * from "../../services/ticketing/Tickets.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports